module.exports = __webpack_public_path__ + "img/icon_refresh.e020fdee.png";